<template>
	<div class="info-view">
		<slot />
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>
	.info-view {
		border: 1px solid #f7223f;
		color: #f7223f;
		padding: 10px;
		border-radius: 5px;
	}
</style>